<template>
    <div class="rounded-[10px] px-4 py-6 shadow-[0_12px_12px_0px_rgba(12,12,13,.05)]">
        <slot />
    </div>
</template>
